export const STAGING_FEEDBACK = 'https://airtable.com/shrmQ2zIf657G10ue';
export const PROD_FEEDBACK = 'https://airtable.com/shrJVjb9dMUjNc3tJ';
